import HydraCallback from '../../pages/HydraCallback';
import LoginV3 from '../../pages/Login/v3';
import Register from '../../pages/Register';

const publicRoutes = [
  {
    path: '/login',
    title: 'Login',
    component: () => <LoginV3 />,
  },
  {
    path: '/register',
    title: 'Register',
    component: () => <Register />,
  },
  {
    path: '/hydra-callback',
    title: 'Hydra Callback',
    component: () => <HydraCallback />,
  },
];

export default publicRoutes;
